import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { useSourceSelectOptions } from "components/UI/Selects/SourceSelectSearchable/useSourceSelectOptions.ts";

export const SourceSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useSourceSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.source"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
